// LIMITE DE ERRO — o que a criança vê quando alguma coisa quebra.
//
// Antes disto, qualquer exceção lançada durante o render derrubava a árvore inteira e a
// plataforma virava uma página BRANCA, sem texto, sem botão, sem explicação. Foi medido: com o
// Firebase sem chave, `/biblioteca` fazia exatamente isso.
//
// Página em branco é a pior falha possível aqui por dois motivos. Uma criança não tem vocabulário
// para relatar "a tela ficou branca" de um jeito que ajude ninguém a consertar, e uma professora
// no meio de uma aula com trinta alunos não vai abrir o console do navegador. O que ambas
// precisam é uma frase em português e um botão.
//
// O que este componente NÃO faz, de propósito: esconder o erro. Ele reaparece no console
// completo, com pilha, porque quem está depurando precisa dele inteiro.

import { Component, ErrorInfo, ReactNode } from "react";

type Props = {
  children: ReactNode;
  /** Nome da área, para a mensagem dizer o que falhou em vez de "algo". */
  area?: string;
};

type State = { erro: Error | null };

class LimiteDeErro extends Component<Props, State> {
  // Precisa ser classe: em 2026 o React ainda não tem equivalente em hook para
  // `componentDidCatch`. Não é escolha de estilo.
  state: State = { erro: null };

  static getDerivedStateFromError(erro: Error): State {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo) {
    console.error("[HQ-Lab] erro não tratado:", erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;

    const area = this.props.area;

    return (
      <div role="alert" className="limite-de-erro">
        <div className="limite-de-erro-cartao">
          <p className="limite-de-erro-marca">HQ-Lab</p>
          <h1>Alguma coisa deu errado{area ? ` em ${area}` : ""}.</h1>
          <p>
            Não foi culpa sua. A gente não conseguiu montar esta tela agora —
            seus quadrinhos continuam salvos.
          </p>
          <div className="limite-de-erro-botoes">
            <button type="button" onClick={() => window.location.reload()}>
              Tentar de novo
            </button>
            <a href="/">Voltar para o início</a>
          </div>
          {/* O detalhe técnico fica atrás de um clique: quem precisa dele sabe procurar, e
              quem não precisa não leva um texto em inglês na cara. */}
          <details>
            <summary>Detalhe técnico</summary>
            <code>{this.state.erro.message}</code>
          </details>
        </div>
      </div>
    );
  }
}

export default LimiteDeErro;
